import React from 'react';

type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

const SpeakersIcon = (props: Props) => {
  const { width = '20', height = '20', strokeColor = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      {/* Head circle */}
      <path
        d="M8 7C9.38071 7 10.5 5.88071 10.5 4.5C10.5 3.11929 9.38071 2 8 2C6.61929 2 5.5 3.11929 5.5 4.5C5.5 5.88071 6.61929 7 8 7Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Shoulders/body */}
      <path
        d="M13 14C13 11.2386 10.7614 9 8 9C5.23858 9 3 11.2386 3 14"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SpeakersIcon;
